import { ModelDefinitionFields } from "./fields";

export type ModelDefinition = {
    readonly name: string;
    readonly description: string;
    readonly fields: ModelDefinitionFields;
    readonly displayField?: string;
};

export function model<M extends ModelDefinition>(definition: M): M {
    return Object.freeze(definition);
}
